define('EideBailly.ProductInventoryByLocation.ProductInventoryByLocation.View',
    [
        'ProductInventoryByLocation.Model',
        'eidebailly_productinventorybylocation_productinventorybylocation.tpl',
        'AjaxRequestsKiller',
        'Utils',
        'Backbone',
        'jQuery',
        'underscore'
    ]
    , function (
        ProductInventoryByLocationModel,
        eidebailly_productinventorybylocation_productinventorybylocation_tpl,
        AjaxRequestsKiller,
        Utils,
        Backbone,
        jQuery,
        _
    ) {
        'use strict';
        return Backbone.View.extend({

            template: eidebailly_productinventorybylocation_productinventorybylocation_tpl

            , initialize: function (options) {
                this.model = options.model;
                this.model.on('change', this.render, this);
            }

            , events: {}

            , bindings: {}

            , childViews: {}

            , normalizeColumns: function () {
                return _.map(this.model.get('locations'), function (column) {
                    return {
                        name: [column.name, Utils.translate('Store')].join(' '),
                        availablequantity: column.locationquantityavailable || 0,
                        state: column.state,
                        address: [column.address1, ', ', column.city, ', ', column.state, ', ', column.country, ' ', column.zip].join('')
                    };
                });
            }
            , getContext: function getContext() {
                var locations = this.normalizeColumns();
                var stockTotal = 0;
                if (locations) {
                    locations.forEach(function (f) {
                        stockTotal += parseInt(f.availablequantity, 10);
                    });
                }
                return {
                    locations: this.normalizeColumns()
                    , stockTotal: stockTotal
                };
            }
        });
    });
